import { render, staticRenderFns } from "./BigScreenForWXCW.vue?vue&type=template&id=209e222d&scoped=true&"
import script from "./BigScreenForWXCW.vue?vue&type=script&lang=js&"
export * from "./BigScreenForWXCW.vue?vue&type=script&lang=js&"
import style0 from "./BigScreenForWXCW.vue?vue&type=style&index=0&id=209e222d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e222d",
  null
  
)

export default component.exports